<template>
    <div id="fileManagement" class="fileManagement">
        <div class="page-content">
            <div class="page-content-head">
                <el-row>
                    <el-col :span="12">
                        <button class="upload-btn" @click.prevent="uploadModel">
                            <i class="icon iconfont iconshangchuan"></i> 上传文件
                        </button>
                        <button class="delete-btn" @click.prevent="batchDeleteModel">
                            <i class="icon iconfont iconshanchu"></i> 删除文件
                        </button>
                        <!-- <button class="refresh-btn" @click.prevent="createNewBucket"> <i class="fa fa-refresh"></i> 创建Bucket</button> -->
                        <button class="refresh-btn" @click.prevent="refreshFileList(false)">
                            <i class="fa fa-refresh"></i> 刷新
                        </button>
                        <button class="refresh-btn" @click.prevent="getModelViewToken" style="width: 180px">
                            <i class="icon iconfont iconliulan-moren icon view"></i> 获取模型viewToken
                        </button>
                    </el-col>
                </el-row>
            </div>
            <div class="page-table-content">
                <div class="bucket-list">
                    <el-collapse v-model="activeList" v-if="bucketItems.length > 0">
                        <el-collapse-item
                            v-for="(item, index) in bucketItems"
                            :title="item.name"
                            :name="item.id"
                            :key="index"
                        >
                            <ul v-if="item.children.length > 0">
                                <li
                                    v-for="(item2, index) in item.children"
                                    class="listItem"
                                    :class="{ activeItem: currentBucket === item2.name }"
                                    :key="index"
                                    @click="changeBucket(item2.name)"
                                >
                                    {{ item2.name }}
                                </li>
                            </ul>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="page-list">
                    <el-table
                        v-loading="isTableLoading"
                        ref="multipleTable"
                        size="mini"
                        height="95%"
                        style="width: 80%"
                        tooltip-effect="dark"
                        border
                        fit
                        highlight-current-row
                        :data="modelsData"
                        :row-class-name="tableRowClassName"
                        :row-style="{ height: '50px', 'font-size': '14px' }"
                        :cell-style="{ padding: '0px' }"
                        :header-cell-style="{
                            'background-color': '#F5F5F5',
                            'font-size': '14px',
                            height: '50px',
                            color: '#666666',
                            'font-weight': '400',
                        }"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="50"> </el-table-column>
                        <el-table-column prop="fileName" label="文件名称" min-width="10%" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="fileUrn" label="文件urn" min-width="15%" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="uploadTime"
                            label="上传时间"
                            sortable
                            min-width="8%"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column prop="size" label="大小" sortable min-width="5%" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="consumingTime"
                            label="耗时（全量/流式）"
                            min-width="8%"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <div class="consuming-time-container">
                                    <div class="consuming-time-item">
                                        <span>{{ scope.row.consumingTime.obv }}</span>
                                    </div>
                                    <div class="consuming-time-item">
                                        <span>{{ scope.row.consumingTime.lod }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="modelStatus" label="模型状态" min-width="7%" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="status-container">
                                    <div class="status-item">
                                        <span v-if="scope.row.modelStatus.obv === '完成转换'" style="color: #22c00e"
                                            >全量转换</span
                                        >
                                        <span
                                            v-else-if="scope.row.modelStatus.obv === '排队等候'"
                                            style="color: #3d94e8"
                                            >排队等侯</span
                                        >
                                        <span
                                            v-else-if="scope.row.modelStatus.obv === '正在转换'"
                                            style="color: #ffaa3e"
                                            >正在转换</span
                                        >
                                        <span
                                            v-else-if="scope.row.modelStatus.obv === '异常退出'"
                                            style="color: #ff4929"
                                            >异常退出</span
                                        >
                                        <span v-else style="color: #c0c4cc">全量转换</span>
                                    </div>
                                    <div class="status-item">
                                        <span v-if="scope.row.modelStatus.lod === '完成转换'" style="color: #22c00e"
                                            >流式转换</span
                                        >
                                        <span
                                            v-else-if="scope.row.modelStatus.lod === '排队等候'"
                                            style="color: #3d94e8"
                                            >排队等侯</span
                                        >
                                        <span
                                            v-else-if="scope.row.modelStatus.lod === '正在转换'"
                                            style="color: #ffaa3e"
                                            >正在转换</span
                                        >
                                        <span
                                            v-else-if="scope.row.modelStatus.lod === '异常退出'"
                                            style="color: #ff4929"
                                            >异常退出</span
                                        >
                                        <span v-else style="color: #c0c4cc">流式转换</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="15%" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <!-- 查看 -->
                                <i
                                    class="iconfont iconliulan-moren icon view"
                                    title="查看"
                                    @click="viewmodel(scope.$index, scope.row)"
                                ></i>
                                <!-- 转换 -->
                                <i
                                    class="iconfont iconxingzhuangbeifen icon convert"
                                    title="转换"
                                    @click="convertConfigDialog(scope.row)"
                                ></i>
                                <!-- 复制urn -->
                                <i
                                    class="iconfont iconcopy icon copy"
                                    title="复制urn"
                                    @click="urnDbClick(scope.row)"
                                ></i>
                                <!-- 删除 -->
                                <i
                                    class="iconfont iconxingzhuang icon delete"
                                    title="删除"
                                    @click="deleteModel(scope.$index, scope.row)"
                                ></i>
                                <!-- 更多 -->
                                <el-dropdown class="needMore icon" @command="handleCommand">
                                    <i class="el-icon-more"></i>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            :command="beforeHandleCommand(scope.$index, scope.row, 'donwLoadFile')"
                                            >下载</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            :command="beforeHandleCommand(scope.$index, scope.row, 'shareFile')"
                                            >分享</el-dropdown-item
                                        >
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-progress
                                    v-if="scope.row.percentage > 0"
                                    type="circle"
                                    :width="30"
                                    :percentage="scope.row.percentage"
                                ></el-progress>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="paging">
                        <el-pagination
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            layout="prev, pager, next"
                            :total="totalCount"
                            :page-size="pageSize"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <fileMngUpload ref="fileMngUpload" :bucketOptions="bucketOptions"></fileMngUpload>
        <viewTokenCom ref="viewTokenCom"></viewTokenCom>
        <modelViews
            ref="modelViews"
            :allJobType="allJobType"
            :objectStatus="objectStatus"
            :convertData="convertData"
        ></modelViews>
        <modelViewsShare ref="modelViewsShare"></modelViewsShare>
        <convertConfig @refreshFileListForSelect="refreshFileListForSelect" ref="convertConfig"></convertConfig>
    </div>
</template>

<script>
import DynamicLoad from 'src/common/js/dynamicLoad';
import RuntimeUtils from 'src/common/js/runtimeUtils';
import { getObjectsDownUrl, createBucket, getAllBucket, deleteObject, getPageObjects } from 'src/utils/modelUtils';
import { getAllJobStatus, newGetAllJobStatus, JOB_STATUS } from 'src/utils/jobUtils';
import { getUserName, setUserName } from 'src/utils/loginUtils';
import { getAppInfo } from 'src/utils/appUtils';

import { formatTime, formatSzie, formatConsumingTime, analysisFileType } from 'src/utils/commonUtils';
import busEvent from 'src/utils/busEventUtils';
import modelViews from '../components/modelViews';
import viewTokenCom from '../components/viewTokenCom';
import fileMngUpload from '../components/fileMng-upload';
import modelViewsShare from 'src/pages/devCenter/consoleLab/components/modelViews-share';
import convertConfig from '../components/convertConfig';

export default {
    name: 'fileManagement',
    components: {
        fileMngUpload,
        viewTokenCom,
        modelViews,
        modelViewsShare,
        convertConfig,
    },
    data() {
        return {
            currentPage: 1, // 默认页数
            totalCount: 0, // 数据总条数
            pageSize: 14, //每页显示条目数
            objectNumber: 0, // 当前页面任务数
            modelStatusArr: [],
            modelChangeArr: [],
            bucket_key: '',
            currentRow: {},
            modelsData: [], //列表模型数据存储的地方
            fileName: '',
            currentUrn: '',
            multipleSelection: [], //多选列表
            activeList: [-1],
            bucketItems: [
                {
                    name: 'bucket列表',
                    id: -1,
                    children: [
                        // {
                        //     name: 'model1',
                        //     id: 1
                        // },
                    ],
                },
            ],
            bucketOptions: [], // 传递给子组件的数据
            currentBucket: '', //当前选中的bucket
            OBVJSStatus: false, // obvjs加载情况
            isTableLoading: false, // 表格加载情况
            allJobType: {
                //文件的所有jobType
                obv: null,
                lod: null,
                cal: null,
            },
            objectStatus: {
                //文件的所有转换状态
                obv: null,
                lod: null,
            },
            convertData: {
                obv: null,
                lod: null,
            }, //文件转换相关的参数
        };
    },
    methods: {
        // 转换配置对话框
        convertConfigDialog(row) {
            this.currentRow = row; // 改变当前所选行
            this.$refs.convertConfig.open(row.fileName); // 传入fileName
        },
        // 点击bucket按钮
        changeBucket(bucketItem) {
            this.isTableLoading = true;
            this.currentPage = 1;
            this.refreshFileList(bucketItem);
        },
        // 获取文件格式
        getFileType(fileName) {
            return analysisFileType(fileName);
        },
        urnDbClick(row) {
            this.$copyText(`${row.fileUrn}`).then(
                (res) => {
                    this.$message.success('复制成功');
                },
                (err) => {
                    this.$message.error('复制失败');
                },
            );
        },
        // 当前页切换
        handleCurrentChange(val) {
            this.currentPage = val;
            this.refreshFileList(this.$store.state.storage.bucketKey);
        },
        // 上传文件
        uploadModel() {
            this.$refs.fileMngUpload.Open(this.$store.state.storage.bucketKey);
        },
        beforeHandleCommand(index, row, command) {
            return {
                index: index,
                row: row,
                command: command,
            };
        },
        handleCommand(command) {
            if (command.row.modelStatus === '排队等候') {
                this.$message.error('文件排队等候中');
            } else if (command.row.modelStatus === '正在转换') {
                this.$message.error('文件转换中');
            } else {
                switch (command.command) {
                    case 'donwLoadFile':
                        this.currentRow = command.row;
                        this.donwLoadFile(command);
                        break;
                    case 'shareFile':
                        this.currentRow = command.row;
                        this.shareFile();
                        break;
                    case 'reDwgConvertor':
                        this.reDwgConvertor(command);
                        break;
                }
            }
        },
        donwLoadFile(command) {
            const tempBucketKey = this.$store.state.storage.bucketKey;
            getObjectsDownUrl(tempBucketKey, this.currentRow.fileName).then((res) => {
                let _self = this;
                // 下载
                function download(url, filename) {
                    _self.getBlob(
                        url,
                        function (blob) {
                            _self.saveAs(blob, filename);
                        },
                        command.index,
                        tempBucketKey,
                    );
                }
                let URL = res.url;
                let fileLength = this.currentRow.fileName.lastIndexOf('_');
                let type = this.currentRow.fileName.substring(fileLength + 1, this.currentRow.fileName.length);
                let modelDownloadName = this.currentRow.fileName.substring(0, fileLength);
                download(URL, modelDownloadName + '.' + type);
            });
        },

        // 获取下载进度
        getBlob(url, cb, index, tempBucketKey) {
            let _self = this;
            let xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response);
                }
            };
            xhr.onprogress = function (e) {
                // e.loaded代表上传了多少
                // e.total代表总数为多少
                _self.modelsData[index].percentage = parseFloat(((e.loaded / e.total) * 100).toFixed(0));
                if (_self.modelsData[index].percentage === 100) {
                    _self.refreshFileList(tempBucketKey);
                }
            };
            xhr.send();
        },
        // 下载文件
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                let link = document.createElement('a');
                let body = document.querySelector('body');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                // fix Firefox
                link.style.display = 'none';
                body.appendChild(link);
                link.click();
                body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }
        },
        shareFile() {
            const tempBucketKey = this.$store.state.storage.bucketKey;
            this.fileName = this.currentRow.fileName;
            this.currentUrn = `urn:bimbox.object:${tempBucketKey}/${this.currentRow.fileName}`;
            this.objectStatus = { obv: this.currentRow.modelStatus.obv, lod: this.currentRow.modelStatus.lod };
            Object.assign(this.currentRow, { type: 1 });
            if (this.currentRow.modelStatus.obv == '完成转换' || this.currentRow.modelStatus.lod == '完成转换') {
                this.$refs.modelViewsShare.Open(
                    {
                        fileName: this.fileName,
                        urn: this.currentUrn,
                        objectStatus: this.objectStatus,
                    },
                    this.currentRow,
                );
            } else {
                this.$message.warning('文件未完成转换！');
            }
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 !== 0) {
                return 'even-row';
            }
            return 'odd-row';
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        batchDeleteModel() {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    this.batchDeleteFun();
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    });
                });
        },
        batchDeleteFun() {
            const multiPro = [];
            const tempBucketKey = this.$store.state.storage.bucketKey;
            this.multipleSelection.forEach((ele) => {
                multiPro.push(deleteObject(tempBucketKey, ele.fileName));
            });
            if (this.multipleSelection.length !== 0) {
                Promise.all(multiPro).then((res) => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!',
                    });
                    if (this.totalCount > 1 && this.objectNumber === this.multipleSelection.length) {
                        this.currentPage = Math.ceil(this.totalCount / this.pageSize) - 1;
                        this.refreshFileList(tempBucketKey);
                    } else {
                        this.refreshFileList(tempBucketKey);
                    }
                });
            } else {
                this.$message.error('请选中要删除的项目');
            }
        },
        // 刷新页面
        refreshFileList(bucketKey) {
            let tempBucketKey = '';
            if (bucketKey) {
                tempBucketKey = bucketKey;
                this.$store.commit('SET_BUCKETKEY', bucketKey);
            } else {
                tempBucketKey = this.$store.state.storage.bucketKey;
            }
            // 对应左侧列表高亮
            this.currentBucket = tempBucketKey;
            this.getPageObjectsFun();
            // 30s自动刷新界面
            setTimeout(() => {
                this.setTimeoutState(bucketKey, () => {
                    this.refreshFileList(this.$store.state.storage.bucketKey);
                });
            }, 1000);
        },
        getPageObjectsFun() {
            let data = {
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
            };
            getPageObjects(this.currentBucket, data)
                .then((res) => {
                    if (res && res.data && res.data.length !== 0) {
                        this.objectNumber = res.data.length;
                        this.totalCount = res.totalObjects;
                        this.modelsData = res.data;
                        this.getAllJobStatusFun();
                    } else {
                        this.modelsData = [];
                        this.objectNumber = 0;
                        this.totalCount = 0;
                        this.isTableLoading = false;
                    }
                })
                .catch(() => {
                    this.modelsData = [];
                    this.objectNumber = 0;
                    this.totalCount = 0;
                    this.isTableLoading = false;
                });
        },
        // 查询job的状态
        getAllJobStatusFun() {
            newGetAllJobStatus(this.currentBucket, this.modelsData).then((res) => {
                for (let index = 0; index < this.modelsData.length; index++) {
                    const modelData = this.modelsData[index];
                    const urn = modelData.fileUrn;
                    if (typeof res.data[urn] === 'undefined') {
                        modelData.modelStatus = {
                            obv: null,
                            lod: null,
                        };
                        modelData.consumingTime = {
                            obv: '-',
                            lod: '-',
                        };
                    } else {
                        modelData.modelStatus = {
                            obv: res.data[urn].obv ? JOB_STATUS[`job_status_${res.data[urn].obv.state}`] : null,
                            lod: res.data[urn].lod ? JOB_STATUS[`job_status_${res.data[urn].lod.state}`] : null,
                        };
                        modelData.consumingTime = {
                            obv: res.data[urn].obv
                                ? formatConsumingTime(res.data[urn].obv.create_at, res.data[urn].obv.update_at)
                                : '-',
                            lod: res.data[urn].lod
                                ? formatConsumingTime(res.data[urn].lod.create_at, res.data[urn].lod.update_at)
                                : '-',
                        };
                    }
                }
                this.isTableLoading = false;
            });
        },
        // 单条转换刷新转换数据
        refreshFileListForSelect(bucketKey) {
            let tempArray = [];
            tempArray.push(this.currentRow);
            let tempBucketKey = '';
            if (bucketKey) {
                tempBucketKey = bucketKey;
                this.$store.commit('SET_BUCKETKEY', bucketKey);
            } else {
                tempBucketKey = this.$store.state.storage.bucketKey;
            }
            // 查询job的状态
            this.getAllJobStatusFun();
            // 30s自动刷新界面
            setTimeout(() => {
                this.setTimeoutState(bucketKey, () => {
                    this.refreshFileListForSelect(this.$store.state.storage.bucketKey);
                });
            }, 1000);
        },
        // TODO 轮循的逻辑是怎么样的
        setTimeoutState(bucketKey, callback) {
            if (this.modelsData.length > 0 && bucketKey === this.$store.state.storage.bucketKey) {
                this.modelsData.forEach((e) => {
                    if (
                        e.modelStatus.obv === '排队等候' ||
                        e.modelStatus.obv === '正在转换' ||
                        e.modelStatus.lod === '排队等候' ||
                        e.modelStatus.lod === '正在转换'
                    ) {
                        this.modelStatusArr.push(e.modelStatus);
                    }
                });
                if (this.modelStatusArr.length > 0) {
                    this.modelStatusArr.forEach((e) => {
                        if (
                            e.obv === '正在转换' ||
                            e.obv === '排队等候' ||
                            e.lod === '正在转换' ||
                            e.lod === '排队等候'
                        ) {
                            this.modelChangeArr.push(e);
                        }
                    });
                    if (this.modelChangeArr.length > 0) {
                        this.modelChangeArr = [];
                    }
                    setTimeout(() => {
                        callback();
                    }, 30000);
                    this.modelStatusArr = [];
                }
            }
        },
        // 模型查看
        viewmodel(index, row) {
            // 先查询任务状态
            const tempBucketKey = this.$store.state.storage.bucketKey;
            const tempModelData = this.modelsData[index];
            newGetAllJobStatus(tempBucketKey, [tempModelData]).then((res) => {
                const urn = tempModelData.fileUrn;
                const statesData = res.data[urn];
                this.updateModelState(tempModelData, statesData); // 修改文件状态
                // 查看具体模型
                if (row.modelStatus.obv === '完成转换' || (row.modelStatus.lod === '完成转换' && this.OBVJSStatus)) {
                    this.updateModelData(statesData);
                    const _modelViews = this.$refs.modelViews; // 取modelViews实例
                    _modelViews.isDisabled.obv = false;
                    _modelViews.isDisabled.lod = false;
                    // 判断全量、流式面板是否禁用
                    if (row.modelStatus.obv !== '完成转换') {
                        _modelViews.typeName = 'lod';
                        _modelViews.isDisabled.obv = true;
                    }
                    if (row.modelStatus.lod !== '完成转换') {
                        _modelViews.typeName = 'obv';
                        _modelViews.isDisabled.lod = true;
                    }
                    // 开启文件多视图
                    if (this.$route.query.version) {
                        _modelViews.OpenV4(row.fileUrn, row.fileName, 'v4');
                    } else {
                        _modelViews.OpenV5(row.fileUrn, row.fileName);
                    }
                } else if (row.modelStatus.obv !== '完成转换' && row.modelStatus.lod !== '完成转换') {
                    this.$message('文件未转换完成');
                } else if (!this.OBVJSStatus) {
                    this.$message('视图文档未初始化');
                }
            });
        },
        // 修改模型状态
        updateModelState(modelData, statesData) {
            if (typeof statesData === 'undefined') {
                modelData.modelStatus = {
                    obv: null,
                    lod: null,
                };
            } else {
                // 表格中的模型状态
                modelData.modelStatus = {
                    obv: statesData.obv ? JOB_STATUS[`job_status_${statesData.obv.state}`] : null,
                    lod: statesData.lod ? JOB_STATUS[`job_status_${statesData.lod.state}`] : null,
                };
            }
            this.objectStatus = {
                obv: modelData.modelStatus.obv,
                lod: modelData.modelStatus.lod,
            };
        },
        // 修改模型数据（jobType、convertData）
        updateModelData(statesData) {
            // 该文件的所有jobType
            this.allJobType = {
                obv: statesData.obv ? statesData.obv.job_type : null,
                lod: statesData.lod ? statesData.lod.job_type : null,
                cal: statesData.cal ? statesData.cal.job_type : null,
            };
            // 该文件的转换状态数据
            this.convertData = {
                obv: {
                    convertCreateTime: statesData.obv ? formatTime(statesData.obv.task_create_at) : null,
                    convertMeta: statesData.obv ? statesData.obv.converter_meta : null,
                },
                lod: {
                    convertCreateTime: statesData.lod ? formatTime(statesData.lod.task_create_at) : null,
                    convertMeta: statesData.lod ? statesData.lod.converter_meta : null,
                },
            };
        },
        // 删除模型
        deleteModel(index, row) {
            const tempBucketKey = this.$store.state.storage.bucketKey;
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    deleteObject(tempBucketKey, row.fileName).then((res) => {
                        if (res === 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!',
                            });
                            if (this.totalCount > 1 && this.objectNumber === 1) {
                                this.currentPage = parseInt(this.totalCount / this.pageSize);
                                this.refreshFileList(tempBucketKey);
                            } else {
                                this.refreshFileList(tempBucketKey);
                            }
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    });
                });
        },
        // 创建bucket
        createNewBucket() {
            const data = {
                // bucket_key: '4uoZVd8B7SJ'
                bucket_key: 'translation_result_v2',
            };
            createBucket(data).then((res) => {});
        },
        // 获取所有的bucket并初始化项目
        getAppAllInit() {
            getAllBucket()
                .then((res) => {
                    const ownerName = getUserName();
                    this.currentBucket = ownerName;
                    if (res.data.buckets.length !== 0) {
                        res.data.buckets.forEach((ele, index) => {
                            if (ele.bucket_key !== 'translation_result_v2') {
                                this.bucketItems[0].children.push({
                                    name: ele.bucket_key,
                                    id: index,
                                });
                                // 给子组件
                                this.bucketOptions.push({
                                    label: ele.bucket_key,
                                    value: ele.bucket_key,
                                });
                            }
                        });
                    }
                    // 查询默认bucket下数据情况
                    this.refreshFileList(this.currentBucket);
                })
                .catch(() => {
                    this.isTableLoading = false;
                });
        },
        getModelViewToken() {
            this.$refs.viewTokenCom.Open();
        },
    },
    mounted() {
        this.isTableLoading = true;
        getAppInfo()
            .then((appRes) => {
                // 判断是否是第一次使用app
                if (appRes.items.length !== 0) {
                    // 保存用户名
                    setUserName(appRes.items[0].owner);
                    // 储存对应的bucket
                    this.$store.commit('SET_BUCKETKEY', appRes.items[0].owner);
                    this.getAppAllInit();
                    // this.refreshFileList()
                } else {
                    this.$router.push('/devcenter/console/myapp');
                }
            })
            .catch(() => {
                this.isTableLoading = false;
            });
        busEvent.$on('refreshList', (bucketKey) => {
            this.refreshFileList(bucketKey);
        });
        // 初始化obvjs
        DynamicLoad.loadJs(RuntimeUtils.instance.obv5JsPath).then((res) => {
            if (res) {
                this.OBVJSStatus = true;
            }
        });
        // 请求converterTypes并保存至store
        this.$store.dispatch('setConverterTypes');
    },
    destroyed() {
        // 关闭上传对话框
        this.$store.commit('SET_FILELIST_STATUS', false);
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.fileManagement >>>
  .el-table-column--selection .cell
    dom_center()
  .el-table td, .el-table th.is-leaf
    border 0px
  .el-table--border th, .el-table__fixed-right-patch
    border 0px
  .el-table
    user-select text
    background-color transparent
  .el-table .odd-row
    background #FFFFFF
  .el-table .even-row
    background #F8F8F8
  .el-col
    display flex
    align-items center
.fileManagement >>>
  .el-table__row
    .icon
      font-size 16px
      color $font-title
      opacity 0.6
      &:not(:last-child)
        margin-right 20px
      &:hover
        color #0C78E2
        opacity 1
        cursor pointer
    .icon.delete
      &:hover
        color rgb(255, 73, 41)
        opacity 1
    .el-progress
      padding 0px 10px
.fileManagement
  background-color $background-darkwhite
  width 88%
  .page-content
    height 100%
    .page-content-head
      height 7%
      min-height 50px
      .el-row
        height 100%
        .el-col
          height 100%
          .upload-btn
            width 100px
            height 40px
            margin-left 4%
            border-radius 20px
            border 0px
            outline none
            background-color rgb(12, 193, 226)
            i
              font-size 16px
          .delete-btn
            width 100px
            height 40px
            margin-left 10px
            border-radius 20px
            border 0px
            outline none
            background-color rgb(255, 73, 41)
            i
              font-size 16px
          .refresh-btn
            width 100px
            height 40px
            margin-left 10px
            border-radius 20px
            border 0px
            outline none
            background-color #0C78E2
            i
              font-size 16px
  .page-content-search
    height 9%
    align-items center
    justify-content space-evenly
    display flex
    color #999999
    .keyword-search
      width 156px
    .search-btn
      color $font-white
      width 115px
      height 40px
      margin-left 19px
      border-radius 20px
      border 0px
      background-color #0C78E2
  .page-table-content
    width 100%
    height 93%
    display flex
    .bucket-list >>>
      .el-collapse
        margin-top 0px
      .el-collapse-item__header
        height 50px
        border-bottom 2px
        border-style solid
        border-color $background-darkwhite
      .el-collapse-item
        background-color $background-white
      .el-collapse-item__content
        padding-bottom 0px
        border-bottom 2px
        border-style solid
        border-color $background-darkwhite
    .bucket-list
      width 9%
      min-width 145px
      margin-left 10px
      margin-right 10px
      overflow auto
      .listItem
        border 0px
        height 50px
        font-size 14px
        dom_center()
        box-sizing border-box
        &:hover
          background-color #F5F5F5
          color $font-activeBlue
        &.activeItem
          background-color #F5F5F5
          color $font-activeBlue
    .page-list
      width 90%
      .consuming-time-container
        display flex
        width 150px
        .consuming-time-item
          width 50%
      .status-container
        display flex
        .status-item
          margin-right 10px
    .page-list >>>
      .el-table
        width 100% !important
        height 93% !important
    .paging
      width 95%
      margin-top 10px
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/fileManagement/fileManagement.vue